import { Component, ComponentInterface, h, Prop, State, Watch } from '@stencil/core';
import { fetchHeaderS3Data } from '../../utils/dataUtils';
import { Notifications, User } from '../ds-contextual-navigation/ds-contextual-navigation';
import { Country } from '../ds-contextual-navigation/components/ds-contextual-navigation-country-selector/ds-contextual-navigation-country-selector';
import { NotificationBellConfig } from '../ds-contextual-navigation/components/ds-header-notification-bell/ds-header-notification-bell';
import { ContactUsConfig } from '../ds-contextual-navigation/components/ds-contextual-navigation-mobile/ds-header-mobile-contact-us/ds-header-mobile-contact-us';
import { Translations } from '../../utils/translations';
import { jsonWatcher } from '../../utils/utils';

@Component({
  tag: 'ds-header'
})
export class SourceS3DemoContextualNavigationComponent implements ComponentInterface {
  /** id for both landing zone and touchpoint json in it is the same for both */
  @Prop() identifier: string;
  @Prop() landingZoneNavVersion: string = 'latest';
  @Prop() touchpointConfigVersion: string = 'latest';
  /** (optional*) landing zone config id. * If identifier attribute is set it's value will be used */
  @Prop({ mutable: true }) landingZoneIdentifier: string;
  /** (optional*) touchpoint config id. * If identifier attribute is set its value will be used */
  @Prop({ mutable: true }) touchpointIdentifier: string;
  @Prop() locale: string = 'en-us';
  @Prop({ attribute: 's3-bucket' }) s3Bucket: string =
    'https://contextualnavigation.api.community.sap.com';
  @Prop() loggedInUser: User | string;
  @Prop() lastVisitedCountry: Country | string;
  @Prop() notifications: Notifications | string;
  @Prop() notificationBellConfig?: NotificationBellConfig | string;
  @Prop() contactUsConfig?: ContactUsConfig | string;
  /** Deprecated: please use loggedInUser.avatarUrl instead */
  @Prop() avatarSourceUrl?: string;
  /** (optional*) translations are fetched from S3 but can be overwritten (selectively or all) */
  @Prop() translations?: Translations | string;
  @Prop() mode?: 'light' | 'default';
  private _translations: Translations;

  @State() componentArguments: {};

  async componentWillLoad(): Promise<void> {
    this.setIdentifiers();
    this.componentArguments = await fetchHeaderS3Data(this);
    this._translations = this.mergeTranslations(
      this.componentArguments['translations'],
      this.translations
    );
  }

  @Watch('identifier')
  @Watch('landingZoneIdentifier')
  @Watch('touchpointIdentifier')
  async updateData() {
    this.setIdentifiers();
    this.componentArguments = await fetchHeaderS3Data(this);
    this._translations = this.mergeTranslations(
      this.componentArguments['translations'],
      this.translations
    );
  }

  private mergeTranslations(translationsFromS3, translationsFromProp) {
    const resolvedProp = jsonWatcher('translations', translationsFromProp);

    return {
      ...translationsFromS3,
      ...resolvedProp?.value
    };
  }

  private setIdentifiers(): void {
    const isBlank = (value) => typeof value !== 'string' || value === '';
    const specificIdNotSet =
      isBlank(this.landingZoneIdentifier) || isBlank(this.touchpointIdentifier);
    if (isBlank(this.identifier) && specificIdNotSet) {
      throw new Error(
        'Either identifier or landing-zone-identifier and touchpoint-identifier should be set on ds-header'
      );
    } else if (specificIdNotSet) {
      this.touchpointIdentifier = this.identifier;
      this.landingZoneIdentifier = this.identifier;
    }
  }

  render() {
    return (
      <ds-contextual-navigation
        {...this.componentArguments}
        lang={this.locale}
        loggedInUser={this.loggedInUser}
        lastVisitedCountry={this.lastVisitedCountry}
        notifications={this.notifications}
        notificationBellConfig={this.notificationBellConfig}
        contactUsConfig={this.contactUsConfig}
        translations={this._translations}
        mode={this.mode}
      >
        <slot name='contact-us' slot='contact-us'></slot>
        <slot name='search-title' slot='search-title'></slot>
        <slot name='search-results' slot='search-results'></slot>
      </ds-contextual-navigation>
    );
  }
}
